import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appFocusNext]'
})

export class FocusNextPrevDirective {
    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) { }

    @HostListener('keyup', ['$event']) public onkeyup($event: any):any {
        const maxLength = this.el.nativeElement.maxLength;
        const myLength = this.el.nativeElement.value.length;
        const datatarget = this.el.nativeElement.attributes.data_target ? this.el.nativeElement.attributes.data_target.value : null;
        const datatargetPrev = this.el.nativeElement.attributes.data_target_prev ?
        this.el.nativeElement.attributes.data_target_prev.value : null;
        if ($event.shiftKey && $event.keyCode === 9 || $event.keyCode === 16 || $event.keyCode === 37) {
            return true;
        } else if (myLength >= maxLength && !($event.keyCode === 9 || $event.keyCode === 16)) {
            const nextInput = document.getElementById(datatarget);
            if (nextInput !== null) {
                nextInput.focus();
            }
        } else if ($event.keyCode === 8 && myLength === 0) {
            const prevInput = document.getElementById(datatargetPrev);
            if (prevInput !== null) {
                prevInput.focus();
            }
        } else {
            return true;
        }
    }
}
